import { connect } from "react-redux";
import { AuthNew } from "./authNew";
import { tryGoogleAuthorisedUserLogin } from "services/redux/auth/login/action";
import { bindActionCreators } from "redux";
import { generateOtp } from "services/redux/auth/loginOtp/action";

const mapStateToProps = (state) => ({
  otp: state.loginOtp.otp,
  login_data: state.loginOtp.login_data,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      generateOtp,
      tryGoogleAuthorisedUserLogin,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AuthNew);
